<div class="multi-choice" [class.multi-disabled]="disabled">
  <div class="choice-option" [class.selected]="isSelected(choice.answerRank)" *ngFor="let choice of answers; index as i" (click)="select(choice.answerRank)">
    <div class="choice-index">
      <span>Option {{i + 1}}</span>
    </div>
    <div class="choice-answer">
      <span>{{choice.possibleAnswer}}</span>
    </div>
  </div>
</div>